import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6ab2a1de&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab2a1de')) {
      api.createRecord('6ab2a1de', component.options)
    } else {
      api.reload('6ab2a1de', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=6ab2a1de&", function () {
      api.rerender('6ab2a1de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/Header.vue"
export default component.exports